import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebaseConfig';

const functions = getFunctions(app);

export interface AdminOverview {
  totalUsers: number;
  proUsers: number;
  freeUsers: number;
  newUsers7d: number;
  newUsers30d: number;
  activeUsers7d: number;
  activeUsers30d: number;
  totalTasks: number;
  totalHabits: number;
  totalLists: number;
  totalNotes: number;
  totalAffirmations: number;
  totalGanttCharts: number;
  totalBudgetCategories: number;
  totalBudgetEntries: number;
  growth: Array<{ date: string; newUsers: number; totalUsers: number }>;
}

export interface AdminUser {
  uid: string;
  email: string;
  displayName: string;
  subscriptionTier: string;
  subscriptionExpirationDate: string | null;
  subscriptionIsTrialPeriod: boolean;
  accountCreatedAt: string | null;
  lastActiveAt: string | null;
  taskCount: number;
  habitCount: number;
  listCount: number;
  noteCount: number;
  affirmationCount: number;
  ganttCount: number;
  budgetCategoryCount: number;
  budgetEntryCount: number;
  feelingCount: number;
  connectionCount: number;
  appVersion: string | null;
  deviceType: string | null;
  deviceModel: string | null;
}

export interface ActivityDay {
  date: string;
  activeUsers: number;
  totalActions: number;
  tasks: number;
  habits: number;
  lists: number;
  notes: number;
  affirmations: number;
  budget: number;
}

export async function getAdminOverview(): Promise<AdminOverview> {
  const fn = httpsCallable<void, AdminOverview>(functions, 'adminGetOverview');
  const result = await fn();
  return result.data;
}

export async function getAdminUsers(): Promise<AdminUser[]> {
  const fn = httpsCallable<void, { users: AdminUser[] }>(functions, 'adminGetUsers');
  const result = await fn();
  return result.data.users;
}

export async function getAdminActivity(days = 60): Promise<ActivityDay[]> {
  const fn = httpsCallable<{ days: number }, { activity: ActivityDay[] }>(functions, 'adminGetActivity');
  const result = await fn({ days });
  return result.data.activity;
}

export async function updateUserSubscription(params: {
  uid: string;
  subscriptionTier: string;
  subscriptionExpirationDate?: string;
  subscriptionIsTrialPeriod?: boolean;
}): Promise<void> {
  const fn = httpsCallable(functions, 'adminUpdateSubscription');
  await fn(params);
}

export async function sendAnnouncement(params: {
  title: string;
  message: string;
  testOnly?: boolean;
}): Promise<{ sent: number; failed: number; total: number }> {
  const fn = httpsCallable<{ title: string; message: string; testOnly?: boolean }, { sent: number; failed: number; total: number }>(functions, 'adminSendAnnouncement');
  const result = await fn(params);
  return result.data;
}
